<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDeny_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M22.586 26.414a2 2 0 1 0 2.828-2.828L16.828 15l8.586-8.586a2 2 0 1 0-2.828-2.828L14 12.172 5.414 3.586a2 2 0 1 0-2.828 2.828L11.172 15l-8.586 8.586a2 2 0 1 0 2.828 2.828L14 17.828z"
        clip-rule="evenodd"
    />
</svg>
